import React from 'react'
import { Chip } from '@mui/material'

const StatusChip = ({ status, size = 'small' }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
      case 'completed':
      case 'approved':
        return 'success'
      case 'pending':
      case 'in-progress':
        return 'warning'
      case 'rejected':
      case 'cancelled':
        return 'error'
      case 'draft':
        return 'default'
      default:
        return 'default'
    }
  }

  return (
    <Chip
      label={status}
      color={getStatusColor(status)}
      size={size}
      variant="filled"
    />
  )
}

export default StatusChip